<template>
  <Modal ref="modalRef" @after-close="resetForm">
    <template #body>
      <View direction="column" gap="md" padding-block="md" class="confirmation">
        <Text variant="h2" align="center">Are you sure you'd like to decline a showing this Renter?</Text>

        <Text variant="body-large" color="secondary" align="center">
          Declining this renter will stop Tallo from it's scheduling efforts. If you proceed, please provide feedback to
          help us improve. Your response won’t be shared with the renter.
        </Text>

        <Textarea
          class="decline-reason-input"
          placeholder="Leave your feedback"
          rows="4"
          v-model="declineReasonInput"
        />
      </View>
    </template>

    <template #footer>
      <Button variant="ghost" @click="close">Cancel</Button>
      <Button :loading="isLoading" @click="declineShowing">Decline showing</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Modal, Textarea, Text, View, useAlertsStore } from '@tallo/design-system';

import { useDeclineShowingRequest } from '../../mutations/decline-showing-request.mutation';

const props = defineProps<{
  propertyId: string;
  showingRequestId: string;
}>();

const emit = defineEmits(['declined']);

const { mutateAsync, isLoading } = useDeclineShowingRequest();
const alertsStore = useAlertsStore();
const modalRef = ref<InstanceType<typeof Modal> | null>(null);
const declineReasonInput = ref('');

function open() {
  modalRef.value?.show();
}

function close() {
  modalRef.value?.close();
}

function resetForm() {
  declineReasonInput.value = '';
}

function declineShowing() {
  mutateAsync({
    propertyId: props.propertyId,
    showingRequestId: props.showingRequestId,
    declineReason: declineReasonInput.value,
  })
    .then(() => {
      emit('declined');
      close();
      alertsStore.success('Showing declined');
    })
    .catch((error) => {
      alertsStore.catchError(error);
    });
}

defineExpose({ open });
</script>

<style scoped lang="scss">
.confirmation {
  max-width: 30rem;
}

.decline-reason-input {
  width: 100%;
}
</style>
